export const SET_ALL_DEALS_LOADING = 'SET_ALL_DEALS_LOADING';
export const GET_ALL_DEALS_SUCCESS = 'GET_ALL_DEALS_SUCCESS';
export const GET_ALL_DEALS_FAILURE = 'GET_ALL_DEALS_FAILURE';
export const SET_SELECTED_DEALS = 'SET_SELECTED_DEALS';